import { ReactElement } from 'react'
import { Item } from 'react-photoswipe-gallery'

export type GalleryItemProps = {
  src: string
  alt?: string
  width?: number | string
  height?: number | string
  className?: string
  style?: React.CSSProperties
  onClick?: (e: React.MouseEvent) => void
  children?: (props: any) => ReactElement
}

export const GalleryItem = ({
  src,
  alt = '',
  width = 768,
  height = 1024,
  className,
  style,
  onClick,
  children,
}: GalleryItemProps) => {
  return (
    <Item original={src} thumbnail={src} width={width} height={height}>
      {(itemProps: any) => {
        const { ref, open } = itemProps

        if (children) {
          return children(itemProps)
        }

        return (
          <img
            alt={alt}
            className={className}
            style={style}
            src={src}
            ref={ref}
            onClick={(e) => {
              e.stopPropagation()
              if (onClick) {
                onClick(e)
              }
              open(e)
            }}
          />
        )
      }}
    </Item>
  )
}
